var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 20.625C34.3875 20.625 35.0063 20.6813 35.625 20.775V7.5C35.625 5.4375 33.9375 3.75 31.875 3.75H9.375C7.3125 3.75 5.625 5.4375 5.625 7.5V37.5C5.625 39.5625 7.3125 41.25 9.375 41.25H22.9875C21.6141 39.2833 20.8063 36.9776 20.6521 34.5838C20.4979 32.19 21.0031 29.7997 22.1129 27.6731C23.2226 25.5464 24.8943 23.7648 26.9461 22.5221C28.9979 21.2795 31.3512 20.6233 33.75 20.625ZM13.125 20.625V7.5H22.5V20.625L17.8125 17.8125L13.125 20.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 24.375C28.575 24.375 24.375 28.575 24.375 33.75C24.375 38.925 28.575 43.125 33.75 43.125C38.925 43.125 43.125 38.925 43.125 33.75C43.125 28.575 38.925 24.375 33.75 24.375ZM31.4062 38.4375V29.0625L38.9062 33.75L31.4062 38.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLesson);
export default __webpack_public_path__ + "static/media/play-lesson.7e74b909ef81b538372b0c865d6573ff.svg";
export { ForwardRef as ReactComponent };